export const DASHBOARD_STATS = 'dashboard_stats'
